module.exports = __webpack_public_path__ + "static/illustration-patient-consent@2x-4a97d2c75253d58ef3f25caf52368dd5.png";